<section class="container sign-container reset-password-container" *ngIf="displayNextStep==false">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
	<section class="navbar-brand">
		<img src="../../assets/img/{{themeService.theme}}/{{themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo'}}.png" alt="Company Logo" width="125px" [ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
	</section>
	<!-- <div class="sign-account" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
	<section class="container" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<form [formGroup]="parentForm" (ngSubmit)="onSubmit()">
			<h1 class="serif-title" [ngClass]="{'nwr-color-title': themeService && themeService.theme == 'NWRTheme'}">Reset Password</h1>
			<section class="sign-get-info">
				<div class="form-group">
					<input type="email" class="form-control" id="resetPasswordMail" placeholder="Email"
						   formControlName="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" required>
					<div *ngIf="submitted && f.email.errors" class="invalid-feedback">
						<div *ngIf="f.email.errors.required">Email is required</div>
						<div *ngIf="f.email.errors.email">Email must be a valid email address</div>
					</div>
				</div>
				<input type="submit" class="form-control btn btn-primary primary-default-btn" value="Reset password" [ngClass]="{'nwr-theme-input': themeService.theme == 'NWRTheme'}">
				<input [routerLink]="['/resetpasswordcontact']" type="submit"
					   class="form-control btn btn-primary primary-default-btn forgot-password"
					   value="I don't know my email address"
					   [ngClass]="{'nwr-theme-input': themeService.theme == 'NWRTheme'}">
				<!-- <div class="sign-account sign-account-mobile" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
				<div class="back-login">
					<a [routerLink]="['/log-in']">Return to log in</a>
				</div>
			</section>
		</form>
	</section>
</section>
<app-reset-password-email-sent *ngIf="displayNextStep" [parentForm]="parentForm"></app-reset-password-email-sent>
<app-footer></app-footer>
